// extracted by mini-css-extract-plugin
export default {"root":"W_mISUq8WB","icon":"sERVk5z1ES","input":"HdsZydIbpN"};